import BaseView from "scripts/views/baseView";
import templateStackedCurationMediaTypesChart from "templates/stackedCurationMediaTypesChart.hbs";

class StackedCurationMediaTypesChartView extends BaseView {
  get template() {
    return templateStackedCurationMediaTypesChart;
  }

  render() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  }
}

export default StackedCurationMediaTypesChartView;
